import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d021a3d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "carousel-container"
}
const _hoisted_2 = { class: "carousel-wrapper" }
const _hoisted_3 = { class: "grid-layout" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "footer" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "title1" }
const _hoisted_9 = { class: "meta" }
const _hoisted_10 = { class: "date" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "footer" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "title2" }
const _hoisted_16 = { class: "meta" }
const _hoisted_17 = { class: "date" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "footer" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "title3" }
const _hoisted_23 = { class: "meta" }
const _hoisted_24 = { class: "date" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "footer" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "title4" }
const _hoisted_30 = { class: "meta" }
const _hoisted_31 = { class: "date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_dashboard_grid = _resolveComponent("dashboard-grid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.slideGroups.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "arrow left",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevSlide && _ctx.prevSlide(...args)))
          }, [
            _createVNode(_component_va_icon, {
              name: "arrow_back",
              style: {"font-size":"18px"}
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "carousel-track",
              style: _normalizeStyle({ transform: `translateX(-${_ctx.currentIndex * 100}%)` })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slideGroups, (group, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "carousel-slide",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    (group[0])
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "grid-item picture",
                          onClick: ($event: any) => (_ctx.openItem(group[0]))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.extractImgUrl(group[0]),
                            alt: group[0]?.indlaeg_slug
                          }, null, 8, _hoisted_5),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("button", {
                              class: "category-badge",
                              onClick: (event) => _ctx.goToCategories(group[0]?.indlaeg_kategori_id?.indlaeg_kategori_titel, event)
                            }, _toDisplayString(group[0]?.indlaeg_kategori_id?.indlaeg_kategori_titel || "No Category"), 9, _hoisted_7),
                            _createElementVNode("div", _hoisted_8, _toDisplayString(group[0]?.indlaeg_versionerings_id?.[0]?.indlaeg_versionering_titel || "No Title"), 1),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("span", _hoisted_10, [
                                _createVNode(_component_va_icon, {
                                  size: "15px",
                                  name: "schedule"
                                }),
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(group[0]?.updatedAt)), 1),
                                _createVNode(_component_va_icon, {
                                  size: "15px",
                                  name: "visibility"
                                }),
                                _createElementVNode("span", null, _toDisplayString(group[0]?.indlaeg_visninger || 0), 1)
                              ])
                            ])
                          ])
                        ], 8, _hoisted_4))
                      : _createCommentVNode("", true),
                    (group[1])
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "grid-item two",
                          onClick: ($event: any) => (_ctx.openItem(group[1]))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.extractImgUrl(group[1]),
                            alt: group[1]?.indlaeg_slug
                          }, null, 8, _hoisted_12),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("button", {
                              class: "category-badge",
                              onClick: (event) => _ctx.goToCategories(group[1]?.indlaeg_kategori_id?.indlaeg_kategori_titel, event)
                            }, _toDisplayString(group[1]?.indlaeg_kategori_id?.indlaeg_kategori_titel || "No Category"), 9, _hoisted_14),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(group[1]?.indlaeg_versionerings_id?.[0]?.indlaeg_versionering_titel || "No Title"), 1),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("span", _hoisted_17, [
                                _createVNode(_component_va_icon, {
                                  size: "15px",
                                  name: "schedule"
                                }),
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(group[1]?.updatedAt)), 1),
                                _createVNode(_component_va_icon, {
                                  size: "15px",
                                  name: "visibility"
                                }),
                                _createElementVNode("span", null, _toDisplayString(group[1]?.indlaeg_visninger || 0), 1)
                              ])
                            ])
                          ])
                        ], 8, _hoisted_11))
                      : _createCommentVNode("", true),
                    (group[2])
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "grid-item three",
                          onClick: ($event: any) => (_ctx.openItem(group[2]))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.extractImgUrl(group[2]),
                            alt: group[2]?.indlaeg_slug
                          }, null, 8, _hoisted_19),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("button", {
                              class: "category-badge",
                              onClick: (event) => _ctx.goToCategories(group[2]?.indlaeg_kategori_id?.indlaeg_kategori_titel, event)
                            }, _toDisplayString(group[2]?.indlaeg_kategori_id?.indlaeg_kategori_titel || "No Category"), 9, _hoisted_21),
                            _createElementVNode("div", _hoisted_22, _toDisplayString(group[2]?.indlaeg_versionerings_id?.[0]?.indlaeg_versionering_titel || "No Title"), 1),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("span", _hoisted_24, [
                                _createVNode(_component_va_icon, {
                                  size: "15px",
                                  name: "schedule"
                                }),
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(group[2]?.updatedAt)), 1),
                                _createVNode(_component_va_icon, {
                                  size: "15px",
                                  name: "visibility"
                                }),
                                _createElementVNode("span", null, _toDisplayString(group[2]?.indlaeg_visninger || 0), 1)
                              ])
                            ])
                          ])
                        ], 8, _hoisted_18))
                      : _createCommentVNode("", true),
                    (group[3])
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: "grid-item four",
                          onClick: ($event: any) => (_ctx.openItem(group[3]))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.extractImgUrl(group[3]),
                            alt: group[3]?.indlaeg_slug
                          }, null, 8, _hoisted_26),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("button", {
                              class: "category-badge",
                              onClick: (event) => _ctx.goToCategories(group[3]?.indlaeg_kategori_id?.indlaeg_kategori_titel, event)
                            }, _toDisplayString(group[3]?.indlaeg_kategori_id?.indlaeg_kategori_titel || "No Category"), 9, _hoisted_28),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(group[3]?.indlaeg_versionerings_id?.[0]?.indlaeg_versionering_titel || "No Title"), 1),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("span", _hoisted_31, [
                                _createVNode(_component_va_icon, {
                                  size: "15px",
                                  name: "schedule"
                                }),
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(group[3]?.updatedAt)), 1),
                                _createVNode(_component_va_icon, {
                                  size: "15px",
                                  name: "visibility"
                                }),
                                _createElementVNode("span", null, _toDisplayString(group[3]?.indlaeg_visninger || 0), 1)
                              ])
                            ])
                          ])
                        ], 8, _hoisted_25))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ], 4)
          ]),
          _createElementVNode("button", {
            class: "arrow right",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextSlide && _ctx.nextSlide(...args)))
          }, [
            _createVNode(_component_va_icon, {
              name: "arrow_forward",
              style: {"font-size":"18px"}
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_dashboard_grid)
  ], 64))
}